import { styled, Box as BoxBase } from "@mui/material";

export const CountrySelectFieldContainer = styled(BoxBase)(() => ({
  position: "relative",
}));

export const LoadingIndicator = styled(BoxBase)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "56px",
  width: "100%",
}));
